import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wraps every /teacher-portal/* route.
//   • Unsigned → /login
//   • Signed in but not a teacher → /dashboard, UNLESS ?view_as=<id> is
//     present AND the caller is an examination admin (super_admin or a
//     user granted the `exam_settings` page). This "view as" bypass
//     powers the Teacher Portal Preview button on Examination Settings:
//     admins land on the real portal, but with a banner + back-link,
//     and the backend's /me endpoint returns the target teacher's
//     assignments instead of the admin's own (empty) set.
// `is_teacher` is set by the backend buildPayload when the user's
// role has is_teacher_role=1 OR is conventionally named teacher /
// teachers — see backend/routes/auth.js.
export default function TeacherGuard({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_teacher) return children;
  // Admin view-as bypass — needs the query param AND admin privileges.
  const params  = new URLSearchParams(location.search);
  const viewAs  = params.get('view_as');
  const pages   = Array.isArray(user.pages) ? user.pages : [];
  const isAdmin = user.role === 'super_admin' || pages.includes('exam_settings');
  if (viewAs && isAdmin) return children;
  return <Navigate to="/dashboard" replace />;
}
